<template>
  <v-row class="white spa-tile">
    <v-col md="6" class="pa-0">
      <v-card flat height="100%" class="transparent">
        <div class="pa-12 pb-3 pl-4">
          <img width="400" alt="РЭК Махамбет" contain :src="'/images/' + logo" transition="scale-transition" />
        </div>
        <v-card-subtitle class="headline font-weight-medium pa-12 pt-3"
          >Размещение вагонов на хранение на собственных современных путях отстоя</v-card-subtitle
        >
      </v-card>
    </v-col>
    <v-col md="6" class="pa-3 pt-8">
      <div>
        <img width="100%" alt="РЭК Махамбет" contain :src="'/images/' + wagons" transition="scale-transition" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "sliderblock",

  data: () => ({
    logo: "mblogo.png",
    wagons: "wagons.png"
  })
};
</script>

<style scoped>
.spa-tile {
}
</style>
